export const kPaymentsSignupPath = 'api/v1/payments/checkout'
export const kPaymentsPartnerPath = 'api/v1/payments/partner'
export const kPaymentsSurveyPathV2 = 'api/v1/payments/survey-v2'
export const kPaymentsPortalPath = 'api/v1/payments/portal'
export const kPaymentsSubscriptionPath = 'api/v1/payments/subscription'
export const kPaymentsPreAuthorizationPath = 'api/v1/payments/pre-authorization'
export const kPaymentsSetupIntentPath = 'api/v1/payments/setup_intent'
export const kChatHtmlToDocxPath = '/api/v1/sourceviewer/html_to_docx'

// Assistant (Agent)
export const kAgentAssistantRouterApiBasePath = '/api/v1/assistant' // Non-WebSocket
export const kAgentV2RouterApiBasePath = '/api/v2/agent' // Non-WebSocket
export const kAgentV2ChatBasePath = '/api/v2/agent/chat' // WebSocket
export const kAgentV2MatterApiBasePath = '/api/v2/matter/' // needs trailing slash

// Agent Assistant Source HTML paths
export const kSourceCaselawHtmlAgent = `${kAgentAssistantRouterApiBasePath}/caselaw/html`
export const kSourceLrrHtmlAgent = `${kAgentAssistantRouterApiBasePath}/lrr/html`

// Agent Assistant metadata paths
export const kSourceLrrMetadataAgent = `${kAgentAssistantRouterApiBasePath}/lrr/metadata`

// Source view paths
export const kSourceApiLrr = '/api/v1/lrr/reference'
export const kSourceApiLrrV3 = '/api/v1/lrr_v3/reference' // supports refs with data-versions <= 4

// Government (Metascraper) documents opened by document ID, outside any chat or table reference
export const kAgencyDocumentsApiBasePath = '/api/v1/agency-documents'

// Caselaw HTML
export const kSourceCaseLawHtmlV3 = '/api/v1/caselaw_v3/caselaw_html'
// Caselaw Metadata
export const kSourceCaseLawMetadataV3 = '/api/v1/caselaw_v3/case_metadata'
export const kSourceCaseLawSummaryV3 = '/api/v1/caselaw_v3/case-summary'

// Medical Chronology
export const kMedChronApiBasePath = '/api/v1/med_chron'

// Timeline (Single Matter)
export const kTimelineApiBasePath = '/api/v1/timeline'

// Medical Billing Summaries
export const kMedSummaryApiBasePath = '/api/v1/med_summary'

// Organizations
export const kGetUserOrgData = '/api/v1/organization'
export const kCreateOrganization = '/api/v1/organization/v2'

// Organizations - Admin
export const kOrgBasePath = '/api/v1/organization'

// Citator V2
export const kCitatorGetCaseStatusApiPathV2 = 'api/v1/citator_v2/case-status'
export const kCitatorGetOpinionCitationLinksApiPathV2 = 'api/v1/citator_v2/opinion-citation-links'
export const kCitatorGetCaseCitationsApiPathV2 = 'api/v1/citator_v2/case-citations'
export const kCitatorGetCitingCasesApiPathV2 = 'api/v1/citator_v2/citing-cases'
export const kCitatorGetRelatedCasesApiPathV2 = 'api/v1/citator_v2/related-cases'

// Payments
export const kPaymentsValidatePromoCodeApiPath = '/api/v1/payments/promotion'
export const kPaymentsCheckoutPricesApiPath = '/api/v1/payments/checkout-prices'
export const kPaymentsTrialDaysApiPath = '/api/v1/payments/trial-days'
export const kPaymentsDetailsPath = '/api/v1/payments/payment-details'

// Skills

// Response Feedback
export const kResponseFeedbackBasePath = '/api/v1/assistant/response-feedback'

// Referral
export const kReferralActivatePath = '/api/v1/referral/activate'
export const kReferralCodePath = '/api/v1/referral/code'

// User Settings
export const kSettingsBasePath = '/api/v1/settings'
export const kUserSettingsApiPath = '/api/v1/settings/user'

// User
export const kUserBootstrapPath = '/api/v1/user/bootstrap'
export const kUserLogoutPath = '/api/v1/user/logout'

// Onboarding
export const kPostSignupPhoneApiBasePath = '/api/v1/onboarding/post-signup-phone'
export const kPostSignupPhoneStartPath = `${kPostSignupPhoneApiBasePath}/start`
export const kPostSignupPhoneCompletePath = `${kPostSignupPhoneApiBasePath}/complete`

// Matters
export const kMatterBasePath = '/api/v1/matter/' // needs trailing slash

// User Files
export const kUserFilesApiBasePath = '/api/v1/user-files'
export const kGoogleDriveAuthorizePath = `${kUserFilesApiBasePath}/google-drive/authorize`
export const kDropboxAuthorizePath = `${kUserFilesApiBasePath}/dropbox/authorize`
export const kBoxAuthorizePath = `${kUserFilesApiBasePath}/box/authorize`
export const kOneDriveAuthorizePath = `${kUserFilesApiBasePath}/onedrive/authorize`
export const kClioAuthorizePath = `${kUserFilesApiBasePath}/clio/authorize`
export const kSharePointAuthorizePath = `${kUserFilesApiBasePath}/sharepoint/authorize`
export const kGoogleDriveOAuthCompletePath = `${kUserFilesApiBasePath}/google-drive/oauth/complete`
export const kDropboxOAuthCompletePath = `${kUserFilesApiBasePath}/dropbox/oauth/complete`
export const kBoxOAuthCompletePath = `${kUserFilesApiBasePath}/box/oauth/complete`
export const kOneDriveOAuthCompletePath = `${kUserFilesApiBasePath}/onedrive/oauth/complete`
export const kClioOAuthCompletePath = `${kUserFilesApiBasePath}/clio/oauth/complete`
export const kSharePointOAuthCompletePath = `${kUserFilesApiBasePath}/sharepoint/oauth/complete`
export const kSharePointResolveSitePath = `${kUserFilesApiBasePath}/sharepoint/resolve-site`
export const kSharePointSearchSitesPath = `${kUserFilesApiBasePath}/sharepoint/search-sites`
export const kExternalStorageAccountsPath = `${kUserFilesApiBasePath}/external-storage/accounts`
export const kExternalStorageBasePath = `${kUserFilesApiBasePath}/external-storage`

export const kUserSkillsPath = '/api/v1/user-skills'

export const kFeatureFlagsRuntimePath = '/api/v1/featureflags/runtime'

// Transcription
export const kTranscriptionApiPath = '/api/v2/transcribe'
